import { SignupShell } from '@/features/auth/components/SignupShell';
import { SignupStepHeader } from '@/features/auth/components/SignupStepHeader';
import { OtpInput, OTP_LENGTH } from '@/features/auth/components/OtpInput';
import { ResendTimer } from '@/features/auth/components/ResendTimer';
import { useOtpVerifyPage } from '@/features/auth/hooks/useOtpVerifyPage';

export function OtpVerifyPage() {
  const {
    type,
    otp,
    setOtp,
    steps,
    title,
    destination,
    isPending,
    handleSubmit,
    handleResend,
    handleBack,
  } = useOtpVerifyPage();

  return (
    <SignupShell>
      <div className="signup-form-align flex w-full min-w-0 flex-col">
        {type === 'Forgot' ? (
          <>
            <h1 className="mb-2 text-[22px] font-semibold tracking-tight text-[#0F1817]">
              {title}
            </h1>
            <p className="mb-6 text-sm leading-relaxed text-[#7C8B88]">
              We&apos;ve sent a code to {destination}
            </p>
          </>
        ) : (
          <SignupStepHeader
            step={steps.otp}
            totalSteps={steps.totalSteps}
            title={title}
            subtitle={`We've sent a code to ${destination}`}
          />
        )}

        <OtpInput value={otp} onChange={setOtp} disabled={isPending} />

        <button
          type="button"
          disabled={isPending || otp.join('').length !== OTP_LENGTH}
          onClick={handleSubmit}
          className="signup-btn mb-4 flex h-[46px] w-full items-center justify-center rounded-[9px] border-none text-[14.5px] font-semibold text-white transition-all hover:enabled:-translate-y-px disabled:cursor-not-allowed disabled:opacity-45"
        >
          {isPending
            ? 'Verifying…'
            : type === 'Phone'
              ? 'Verify & continue'
              : 'Verify'}
        </button>

        <ResendTimer key={type} initialSeconds={120} onResend={handleResend} />

        <button
          type="button"
          onClick={handleBack}
          className="mt-6 border-none bg-transparent p-0 text-sm text-[#7C8B88] transition-colors hover:text-[#0F1817]"
        >
          {type === 'Forgot' ? '← Back to forgot password' : '← Back to signup'}
        </button>
      </div>
    </SignupShell>
  );
}
